module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"click_chart_to_display_transactions":"Нажмите на графике, чтобы посмотреть доходы и расходы за день"},"en":{"click_chart_to_display_transactions":"Click on the chart to display transactions"}}')
  delete Component.options._Ctor
}
